import { render } from "./EmptyCasePage.vue?vue&type=template&id=7a523b89&ts=true"
import script from "./EmptyCasePage.vue?vue&type=script&lang=ts"
export * from "./EmptyCasePage.vue?vue&type=script&lang=ts"

import "./EmptyCasePage.vue?vue&type=style&index=0&id=7a523b89&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__